import { Link } from "react-router-dom";
import { FileDown } from "lucide-react";

/**
 * PDF report button. Right-aligned, used under the header on parent pages
 * on the same row as the student name title.
 */
export const PdfReportButton = ({ studentId, month = null, label = "Shkarko PDF" }) => {
    const url = month ? `/parent/student/${studentId}/report?month=${month}` : `/parent/student/${studentId}/report`;
    return (
        <Link to={url} data-testid="pdf-report-btn"
            className="inline-flex items-center gap-2 bg-oxford text-white text-sm font-semibold rounded-lg px-4 py-2.5 hover:bg-oxfordhover transition self-start sm:self-auto"
        >
            <FileDown className="w-4 h-4" /> {label}
        </Link>
    );
};
